import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {microsite,microsites,micrositeEnabled,micrositeCover,micrositeConfig} = api

/**
 * 查找
 */
export async function findMicrosites(params) {
    return request({url: microsites, method: 'get', data: params,})
}
/**
 * 创建
 */
export async function createMicrosites(params) {
    return request({url: microsites, method: 'post', data: params,})
}

/**
 * 编辑
 */
export async function updateMicrosite(params) {
    return request({url: microsite, method: 'put', data: params,})
}
/**
 * 编辑
 */
export async function updateMicrositeCover(params) {
    return request({url: micrositeCover+'?cover='+params.cover, method: 'put', data: params,})
}
/**
 * 禁用
 */
export async function setMicrositeEnabled(params) {
    return request({url: micrositeEnabled, method: 'put', data: params,})
}
/**
 * 删除
 */
export async function deleteMicrosite(params) {
    return request({url: microsite, method: 'delete', data: params,})
}

/**
 * 配置
 */
export async function findMicrositeConfig(params) {
    return request({url: micrositeConfig, method: 'get', data: params,})
}
export async function updateMicrositeConfig(params) {
    return request({url: micrositeConfig, method: 'put', data: params,})
}





// WEBPACK FOOTER //
// ./src/services/microsite.js